// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import pageTemplate from './routes/page-template';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  pageTemplate,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// zoom image
import mediumZoom from 'medium-zoom/dist/medium-zoom.min';
mediumZoom('.zoom-on-click img', {
  margin: 24,
  background: '#212530',
});

// <!----- set meta user-id and session-id
import { DeviceUUID } from 'device-uuid/lib/device-uuid';
import { v4 as uuidv4 } from 'uuid';

jQuery(function ($) {
  var device_uuid = new DeviceUUID().get();
  var session_uuid = uuidv4();

  $('input[name="nndc-footer__user-id"]').val(device_uuid);
  $('input[name="nndc-footer__session-id"]').val(session_uuid);

  /* If browser back button was used, flush cache */
  (function () {
    window.onpageshow = function(event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  })();
});
// -----!> set meta user-id and session-id



// WEBPACK FOOTER //
// ./scripts/main.js